import { FC } from 'react';
import { AccessibilityProvider } from '../../context/accessibility/accessibilityContext';
import { StyledItemsGroup, StyledPrimaryMenu } from './PrimaryMenu.styled';
import { PrimaryMenuProps } from './PrimaryMenu.types';
import { unicornDevToolsContainerId } from '../../unicorn-wrapper/ui/ProductBar/DevModeTools';

export const PrimaryMenuCommon: FC<PrimaryMenuProps> = ({ topItems, bottomItems }) => (
  <>
    <StyledItemsGroup>
      {topItems}
      <div id={unicornDevToolsContainerId} />
    </StyledItemsGroup>
    <StyledItemsGroup>{bottomItems}</StyledItemsGroup>
  </>
);

export const PrimaryMenu: FC<PrimaryMenuProps> = ({ topItems, bottomItems, isDisabled, ...rest }) => (
  <AccessibilityProvider isDisabled={isDisabled}>
    <StyledPrimaryMenu isDisabled={isDisabled} aria-disabled={isDisabled} data-test="primary-menu" {...rest}>
      <PrimaryMenuCommon topItems={topItems} bottomItems={bottomItems} />
    </StyledPrimaryMenu>
  </AccessibilityProvider>
);
